import { DateObject } from '@uplift/services';


export const abbreviateWeekday = (date: DateObject): string => {
  if (date?.isValid()) {
    return {
      Monday: 'Mon.',
      Tuesday: 'Tues.',
      Wednesday: 'Wed.',
      Thursday: 'Thurs.',
      Friday: 'Fri.',
      Saturday: 'Sat.',
      Sunday: 'Sun.',
    }[date.format('dddd')];
  }
  return '';
};
